import * as actionTypes from './actionTypes';

export const pokerTrTLoaded = (tickets) => ({
  type: actionTypes.poker.POKER_TRT_LOADED,
  tickets: tickets,
});
export const pokerTrTFetch = () => ({
  type: actionTypes.poker.POKER_TRT_FETCH,
});

export const pokerTrTRemove = (bonusID) => ({
  type: actionTypes.poker.POKER_TRT_REMOVE,
  code: bonusID,
});

export const pokerTrTLoading = (status) => ({
  type: actionTypes.poker.POKER_TRT_LOADING,
  status: status,
});

export const pokerTournamentsByTournamentTypesFetch = (trt, tournamentTypes) => ({
  type: actionTypes.poker.POKER_TRT_FETCH_TOURNAMENTS_BY_TOURNAMENT_TYPES,
  tournamentTypes: tournamentTypes,
  trt: trt,
});

export const pokerTournamentsByTournamentTypesLoaded = (data) => ({
  type: actionTypes.poker.POKER_TRT_FETCH_TOURNAMENTS_BY_TOURNAMENT_TYPES_LOADED,
  data: data,
});
